export const vueAdminMenuMode = {
  menu: true,
  options: {
    placement: 'bottom-start',
    arrow: false,
    offset: [0, 4],
    maxWidth: 'none'
  },
  flipOptions: {
    fallbackPlacements: ['bottom-start', 'top-start']
  }
}
